module.exports = __webpack_public_path__ + "static/media/fly0091.b4bc7996.webp";